import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  DialogTitle,
} from '@material-ui/core';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const ApiErrors = ({ open, onClose, message }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="request-errors">
      <DialogTitle id="request-errors">An error occurred while processing your request</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          {message.error}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ApiErrors.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
};

export default withMobileDialog()(ApiErrors);
